import React, {useContext, useEffect, useState} from "react";
import Spinner, {SpinnerSize} from "../../../../components/Spinner.jsx";
import {LeadCalculationApi} from "../../../../api/authority/generated/index";
import DoughnutChart from "../../../../mosaic/charts/DoughnutChart.jsx";
import {useTranslation} from "react-i18next";
import {getContrastBackgroundColors, getContrastBackgroundHoverColors} from "../../../../utils/graphColors.js";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import toast from "react-hot-toast";

export default function LeadsByCategoryOverview({project, since, until}) {

    let {getAuthorityConfiguration} = useContext(GlobalContext);

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [data, setData] = useState(null);

    let authorityConfiguration = getAuthorityConfiguration();

    useEffect(() => {
            new LeadCalculationApi(authorityConfiguration)
                .categoryOverview({
                    projectId: project.id,
                    dateRangeInput: {
                        since: since.format('YYYY-MM-DD'),
                        until: until.format('YYYY-MM-DD'),
                    }
                }).then(setData).catch(e => et(e).then((message) => { if (message) toast.error(message); }));

        },

        [since.format('YYYY-MM-DD'), until.format('YYYY-MM-DD'), project.id]
    );

    if (data === null) {
        return <div className="flex flex-col justify-center items-center">
            <Spinner size={SpinnerSize["spinner-large"]}/>
        </div>;
    }

    let result = [];
    for (let categoryKey of Object.keys(data.leadsByCategory)) {
        let category = data.leadsByCategory[categoryKey];
        const chartData = {
            labels: Object.keys(category),
            datasets: [
                {
                    label: t('leads.category-x', {category: categoryKey}),
                    data: Object.values(category),
                    backgroundColor: getContrastBackgroundColors(),
                    hoverBackgroundColor: getContrastBackgroundHoverColors(),
                    borderWidth: 0,
                },
            ],
        };

        result.push(
            <div key={categoryKey}
                 className="comp__roundedBox flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700">
                <header className="px-5 py-4 border-b border-slate-100 dark:border-slate-700">
                    <h2 className="font-semibold text-slate-800 dark:text-slate-100">{t('leads.category-x', {category: categoryKey})}</h2>
                </header>
                {/* Chart built with Chart.js 3 */}
                {/* Change the height attribute to adjust the chart height */}
                <DoughnutChart data={chartData} width={389} height={260}/>
            </div>
        );
    }

    return result;
}
